import React from 'react';
import { useListingData } from 'hooks';

/**
 * It's convergence connector for listing data. These data could be for
 * categories, brands, private sales or more.
 * @param {Component} Component has injected listingData
 */
export default function withListingData(Component) {
    return props => <Component {...useListingData()} {...props} />;
}
